module.exports = __webpack_public_path__ + "za.svg?3c7ba32d93bb0417bfb1d8d0221d9d24";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/za.svg
// module id = 1173
// module chunks = 27